"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getGlobalValue(mapping) {
    if (mapping.value) {
        return mapping.value;
    }
    // Stubbed at the moment
    return mapping.key;
}
exports.getGlobalValue = getGlobalValue;
//# sourceMappingURL=globalStore.js.map